/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { Row } from '@squiz/sds';
import { AI_STRINGS } from 'apps/artificial-intelligence/src/Constants/Strings.constants';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const SemanticAuditorTestResults = (): JSX.Element => {
  const { t } = useTranslation();
  const labels = {
    testRuns: t(AI_STRINGS.testRuns),
    thereAreCurrentlyTestNoResults: t(AI_STRINGS.thereAreCurrentlyNoTestResults),
  };
  // TODO: Add non-empty state
  return (
    <Row
      border={false}
      classes={clsx('semantic-auditor-test-results', {
        ['empty']: true,
      })}
      title={labels.testRuns}
    >
      <span className="semantic-auditor-test-results__empty-text">{labels.thereAreCurrentlyTestNoResults}</span>
    </Row>
  );
};
